export default __webpack_public_path__ + "static/media/CNo.79-1.2ba42b41.jpg";